import { useTranslation } from 'react-i18next';

const getFormFieldsConfig = (t: (key: string, options?: any) => string) =>
  [
    {
      key: 'automateHiringAfterOffer',
      type: 'switch',
      label: t('positionParameters.automateHiringAfterOffer.label'),
      description: t('positionParameters.automateHiringAfterOffer.description'),
    },
    {
      key: 'maxBookmarkAge',
      type: 'numeric',
      label: t('positionParameters.maxBookmarkAge.label'),
      description: t('positionParameters.maxBookmarkAge.description'),
      min: 0,
      max: 90,
      unit: t('positionParameters.daysUnit'),
    },
    {
      key: 'overbookingFactor',
      type: 'numeric',
      label: t('positionParameters.overbookingFactor.label'),
      description: t('positionParameters.overbookingFactor.description'),
      min: 0,
      max: 10,
      unit: undefined,
      isDecimal: true,
    },
    {
      key: 'maxLimitInterviews',
      type: 'numeric',
      label: t('positionParameters.maxLimitInterviews.label'),
      description: t('positionParameters.maxLimitInterviews.description'),
      min: 0,
      max: 100,
      unit: undefined,
    },
    {
      key: 'shouldOverlap',
      type: 'switch',
      label: t('positionParameters.shouldOverlap.label'),
      description: t('positionParameters.shouldOverlap.description'),
    },
    {
      key: 'requisitionActiveThresholdDays',
      type: 'numeric',
      label: t('positionParameters.requisitionActiveThresholdDays.label'),
      description: t('positionParameters.requisitionActiveThresholdDays.description'),
      min: 1,
      max: 90,
      unit: t('positionParameters.daysUnit'),
    },
  ] as const;

export type FieldConfig = ReturnType<typeof getFormFieldsConfig>[number];

export const usePositionParametersFormFields = () => {
  const { t } = useTranslation('createJobPosition');
  return getFormFieldsConfig(t);
};
